
    document.addEventListener('DOMContentLoaded', function(){ 
    	//look for price divs #pnl-request-quote .price
       var prices = document.querySelectorAll("#pnl-request-quote .price");
        prices.forEach(function(priceItem) {
          //if the content of the price is 0 then do not display anything
          
          //remove all non-numeric characters
          strPrice = priceItem.textContent.replace(/\D/g,'');
          if(strPrice != ''){
            
            //if price == 0 set the content to be empty
            if(Number(strPrice) == 0){
             priceItem.innerHTML = ''; 
            }
          }
          
        });
    }, false);
